import axios from "axios";
import moment from "moment";
import { roles } from "../../../configs/constants";

export const dispatchUrlsByType = urls => {
  //   const mapping = {
  //     mobile_app: "mobile",
  //     user: "user",
  //     sector_pdcs: "sector",
  //     visit: "visit",
  //     events: "event",
  //     expenses: "expense",
  //     event: "event",
  //     activerange: "activerange",
  //     statistics: "statistics",
  //     trip: "trip",
  //     attendance: "attendance",
  //     trips: "trip",
  //     mealpackages: "mealpackage",
  //     attendances: "attendance",
  //     expense: "expense",
  //     vacations: "vacation",
  //     users: "users",
  //     pdc: "pdc",
  //     pdcs: "pdc"
  //   };
  const result = urls.reduce((acc, url) => {
    const parts = url.split("/");
    const type = parts[2].split("?")[0].split("/")[0];
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});
  return transformResultToData(result);
};

export const dispatchUrls = (users, nbVisits, [urls, urls2, urls3, urls4]) => {
  const allUrls = [...urls, ...urls2, ...urls3, ...urls4];

  const result = {};

  allUrls.forEach(url => {
    const type = url;
    result[type] = result[type] || { count1: 0, count2: 0, count3: 0, count4: 0 };
  });

  urls.forEach(url => {
    const type = url;
    result[type].count1++;
  });

  urls2.forEach(url => {
    const type = url;
    result[type].count2++;
  });

  urls3.forEach(url => {
    const type = url;
    result[type].count3++;
  });

  urls4.forEach(url => {
    const type = url;
    result[type].count4++;
  });
  return transformResultToData(result, users, nbVisits);
};
const transformResultToData = (result, users, nbVisits) => {
  const urlsEntries = Object.entries(result).map(([key, value]) => ({
    key: key,
    type: key,
    count1: value.count1 || 0,
    count2: value.count2 || 0,
    count3: value.count3 || 0,
    count4: value.count4 || 0
  }));
  const usersEntries = {
    key: "users",
    type: "users",
    count1: users[0],
    count2: users[1],
    count3: users[2],
    count4: users[3]
  };
  const visitsEntries = {
    key: "visits",
    type: "visits",
    count1: nbVisits[0],
    count2: nbVisits[1],
    count3: nbVisits[2],
    count4: nbVisits[3]
  };
  return [usersEntries, visitsEntries, ...urlsEntries];
};

export const columnsUrls = rangeDate => [
  {
    title: "Type",
    dataIndex: "type",
    key: "type"
  },
  {
    title: `week${moment(rangeDate[0]).week()} ${moment(rangeDate[0]).year()} (current week)`,
    dataIndex: "count1",
    key: "count1"
  },
  {
    title: `week${moment()
      .add(-1, "week")
      .week()}  ${moment().year()}`,
    dataIndex: "count2",
    key: "count2"
  },
  {
    title: `week${moment()
      .add(-1, "week")
      .add(-1, "month")
      .week()}  ${moment().year()}`,
    dataIndex: "count3",
    key: "count3"
  },
  {
    title: `week${moment()
      .add(-1, "week")
      .add(-3, "month")
      .week()}  ${moment().year()}`,
    dataIndex: "count4",
    key: "count4"
  }
];
export const columnsUsers = rangeDate => [
  {
    title: "email",
    dataIndex: "email",
    key: "email"
  },
  {
    title: "role",
    dataIndex: "role_label",
    key: "role_label"
  },
  {
    title: "clients",
    dataIndex: "clients",
    key: "clients",
    render: clients => clients.map(client => client.label).join(", ")
  }
];
const baseapi = process.env.REACT_APP_API + "/api";
export const getUrlsBacklogs = async (token, rangeDate) => {
  const response = await axios.post(
    `${baseapi}/backlogs`,
    {
      match: {
        created_at: { $gte: { $date: rangeDate[0] }, $lte: { $date: rangeDate[1] } },
        email: { $nin: ["api-admin@upsell.fr", "tsirizo.rabenoro@upsell.fr", "chat.test.2@upsell.fr"] },
        url: {
          $in: [
            "/api/visit/insert",
            "/api/user/me",
            "/api/user/me/pdc/calendars",
            "/api/events/",
            "/api/expenses/user/weeks",
            "/api/sector_pdcs",
            "/api/user/me/surveys/actives",
            "/api/expenses/",
            "/api/attendances/progression",
            "/api/attendances/validate/",
            "/api/mealpackages/validate/",
            "/api/trips/validate/",
            "/api/mealpackage/",
            "/api/sectors/"
          ]
        }
      }
    },
    {
      headers: {
        Authorization: token
      }
    }
  );
  const users = response.data.map(url => url.email);
  const distinctUsers = [...new Set(users)];
  const urls = response.data
    .filter((value, index, self) => {
      return self.map(item => item.email + item.url).indexOf(value.email + value.url) === index;
    })
    .map(item => item.url);
  const visits = response.data.filter(item => item.url === "/api/visit/insert");
  return { urls, nbUsers: distinctUsers.length, nbVisits: visits.length };
};

export const getUsersRolesAndClients = async (emails, token) => {
  const response = await axios.post(
    `${baseapi}/users`,
    {
      match: {
        email: { $in: emails },
        role_id: { $in: [roles.MANAGER, roles.TERRAIN] },
        effectif: true,
        "clients.label": { $exists: true }
      },
      project: {
        email: 1,
        "clients.label": 1,
        role_label: 1
      }
    },
    {
      headers: {
        Authorization: token
      }
    }
  );
  const users = response.data
    .sort((a, b) => {
      const aClients = a.clients.map(client => client.label).join(", ");
      const bClients = b.clients.map(client => client.label).join(", ");
      return aClients.localeCompare(bClients);
    })
    .sort((a, b) => a.role_label.localeCompare(b.role_label));

  return users;
};



// WEBPACK FOOTER //
// src/pages/devs/backLogs/Backlogs.utils.js